<div class="content-body user-list">
  <div class="content-header">
    <div class="content-header-input">
      <div class="d-flex justify-space-between wp-100">
        <button class="action-button primary-button" mat-button (click)="addNewNote(null)">
          <mat-icon>add</mat-icon>
          <span>Add {{this.subModule?'Accounting Policies':'Notes'}}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="mat-table-wrapper">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [(ngModel)]="isAllSelected"
            (change)="selectAll($event)"
            (click)="$event.stopPropagation()"
          ></mat-checkbox>
          Title
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox  [(ngModel)]="element.isSelected" (change)="onCheckBoxSelected($event, element)"></mat-checkbox>
           {{element?.title}}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="w-200">Status</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element?.isActive" class="status-active">Active</span>
          <span *ngIf="!element?.isActive" class="status-archived">InActive</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="w-50"></th>
        <td mat-cell *matCellDef="let element">
          <div class="grid-actions">
            <div class="d-flex align-items-center">
              <button
                  mat-button
                  disableRipple
                  title="Edit"
                  (click)="addNewNote(element)"
                >
                <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
              </button>
              <button
                  mat-button
                  disableRipple
                  title="Delete"
                  (click)="DeleteNote(element)"
                >
                <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
              </button>               
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="column; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: column"></tr>
         <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell"
              [ngClass]="'text-align-center'"
              [attr.colspan]="column.length"
            >
              <span
                *ngIf="
                  dataSource.length === 0
                "
                >{{ commonNotificationText.NoRecordsFound }}</span
              >
              
            </td>
          </tr>
    </table>
  </div>

  <app-card-footer
    *ngIf="totalSelectedRecords > 0"
    [totalSelectedRecords]="totalSelectedRecords"
    [getModuleId]="moduleId"
    (cancelSelectionClick)="cancelSelectionClick()"
    (archiveAndRestoreClick)="archiveAndRestoreClick($event)"
    (deleteClick)="deleteClick()"
  ></app-card-footer>
</div>
